import {
    Component,
    ViewEncapsulation,
    Input,
    OnChanges,
    SimpleChanges,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import {setCulture, Browser} from '@syncfusion/ej2-base';
import {AccumulationChartComponent, AccumulationChart, IAccLoadedEventArgs, AccumulationTheme} from '@syncfusion/ej2-angular-charts';
import {Subscription} from 'rxjs/Subscription';
import {TranslateService, LangChangeEvent} from '@ngx-translate/core';
import {Router} from '@angular/router';

setCulture('ko');

@Component({
    selector: 'ejs-accumulation-chart-component',
    templateUrl: 'ejs-accumulation-chart.component.html',
    styleUrls: ['../syncfusion.custom.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EjsAccumulationChartComponent {
    @Input() public chartData: any;
    @Input() public chartConfig: any;
    @Input() public chartSeries: any;

    @ViewChild('pie')
    public pie: AccumulationChartComponent | AccumulationChart;
    /*public pieangle(e: Event): void {
        let angle: string = (document.getElementById('pieangle') as HTMLInputElement).value;
        this.pie.series[0].startAngle = parseFloat(angle);
        this.pie.series[0].endAngle = parseFloat(angle);
        this.pie.series[0].animation.enable = false;
        document.getElementById('pieangleText').innerHTML = angle;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    };
    public pieradius(e: Event): void {
        let radius: string = (document.getElementById('pieradius') as HTMLInputElement).value;
        this.pie.series[0].radius = radius + '%';
        document.getElementById('pieradiusText').innerHTML = (parseInt(radius, 10) / 100).toFixed(2);
        this.pie.series[0].animation.enable = false;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    };
    public pieexploderadius(e: Event): void {
        let radius: string = (document.getElementById('pieexploderadius') as HTMLInputElement).value;
        this.pie.visibleSeries[0].explodeOffset = radius + '%';
        document.getElementById('pieexploderadiusText').innerHTML = (parseInt(radius, 10) / 100).toFixed(2);
        this.pie.series[0].animation.enable = false;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    };
    public pieexplodeindex(e: Event): void {
        let index: number = +(document.getElementById('pieexplodeindex') as HTMLInputElement).value;
        this.pie.visibleSeries[0].explodeIndex = index;
        document.getElementById('pieexplodeindexText').innerHTML = index.toString();
        this.pie.series[0].animation.enable = false;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    };
    public piecenterx(e: Event): void {
        let x: string = (document.getElementById('x') as HTMLInputElement).value;
        this.pie.center.x = x + '%';
        document.getElementById('xvalue').innerHTML = x + '%';
        this.pie.series[0].animation.enable = false;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    }
    public piecentery(e: Event): void {
        let y: string = (document.getElementById('y') as HTMLInputElement).value;
        this.pie.center.y = y + '%';
        document.getElementById('yvalue').innerHTML = y + '%';
        this.pie.series[0].animation.enable = false;
        this.pie.removeSvg();
        this.pie.refreshSeries();
        this.pie.refreshChart();
    }*/
    /*public animation: Object = {
        enable: false
    };
    //Initializing Legend
    public legendSettings: Object = {
        visible: false,
    };
    //Initializing Datalabel
    public dataLabel: Object = {
        visible: true,
        position: 'Inside', name: 'text',
        font: {
            fontWeight: '600'
        }
    };*/
    // custom code start
    public load(args: IAccLoadedEventArgs): void {
        let selectedTheme: string = location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.accumulation.theme = <AccumulationTheme>(selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/-dark/i, "Dark");
    };
    // custom code end
    // public center: Object = {x: '50%', y: '50%'};
    // public startAngle: number = 0;
    // public endAngle: number = 360;
    // public explode: boolean = true;
    // public enableAnimation: boolean = false;
    // public tooltip: Object = { enable: true, format: '${point.x} : <b>${point.y}%</b>' };
    // public title: string = '';
    constructor() {
        //code
    };
    
    tooltipOverlap() {
      const wontTooltip = document.querySelectorAll('.ng-tooltip')[0];
      return wontTooltip.parentNode.removeChild(wontTooltip);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/syncfusion/chart/ejs-accumulation-chart.component.ts